import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';

import * as cafeActions from '../../redux/cafes/actions';
import ENUMS from '../../enums';

import ShowForPermission from '../../components/ShowForPermission';
import DatePicker from './../../components/FormElements/DatePicker/DatePicker';

const PaymentsFilter = props => {
  let formRefrence = useRef();
  let [fromDate, setFromDate] = useState(' ');
  let [cafeId, setCafeIds] = useState('');
  let [toDate, setToDate] = useState(' ');
  useEffect(() => {
    props.getAllCafeNamesForPanel();
  }, []);

  if (props.cafeNamesList) {
    console.log('props.cafeNamesList', props.cafeNamesList);
  }

  const resetForm = event => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.type === 'radio' || element.type === 'checkbox') {
        element.checked = null;
      } else if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setFromDate(' ');
    setToDate(' ');
    setCafeIds([]);
    props.onSelectCafeIds([]);
    props.applyFilters(event);
  };
  return (
    <article>
      <form
        ref={formRefrence}
        onReset={event => resetForm(event)}
        onSubmit={event => props.applyFilters(event)}
        id="filterForm"
        className="card card my-4"
      >
        <header className="text-center card-header">
          <h5 className="font-italic text-muted">{locales('titles.filter')}</h5>
        </header>
        <main className="card-body">
          <div className="d-flex col-12 justify-content-between">
            <div
              className="d-flex col-md-5 col-sm-12 justify-content-between"
              style={{ gap: '5px' }}
            >
              <DatePicker
                marge={true}
                placeholder="تاریخ شروع"
                name="fromDate"
                id="fromDate"
                onChange={d => setFromDate(d)}
                value={fromDate}
                className="col-6"
              />
              <DatePicker
                marge={true}
                placeholder="تاریخ پایان"
                name="toDate"
                id="toDate"
                onChange={d => setToDate(d)}
                value={toDate}
                className="col-6"
              />
            </div>
            {/* <div className="d-flex col-md-7 col-sm-12 justify-content-end my-5"></div> */}
          </div>
          <ShowForPermission
            permission={ENUMS.PERMISSIONS.values.VIEW_CHECKOUTS_WITH_CAFE_LIST_FOR_ADMIN}
          >
            <div className="d-flex justidy-content-between px-1 my-3">
              <Select
                id="cafeId"
                name="cafeId"
                isMulti={false}
                value={cafeId}
                onChange={selectedCafeIds => {
                  setCafeIds(selectedCafeIds);
                  props.onSelectCafeIds(selectedCafeIds);
                }}
                className="col-md-8 col-sm-12 mx-1"
                options={props.cafeNamesList.map(n => ({
                  label: n.name,
                  value: n.id
                }))}
                placeholder={locales('fields.cafe.name')}
              />
            </div>
          </ShowForPermission>
          <div className="col-12 d-flex justify-content-end p-0">
            <input
              name="resetButton"
              type="reset"
              value={locales('fields.reset')}
              className="btn btn-danger w-5 mx-2"
            />
            <button
              type="submit"
              id="apply-filter-btn-checkoutReservation"
              className="btn btn-success w-5 mx-2"
            >
              {locales('fields.applyFilters')}
            </button>
          </div>
        </main>
      </form>
    </article>
  );
};

const mapStateToProps = state => {
  return {
    cafeNamesLoading: state.cafesReducer.cafeNamesLoading,
    cafeNamesList: state.cafesReducer.cafeNamesList,
    cafeNames: state.cafesReducer.cafeNames,
    cafeNamesFailed: state.cafesReducer.cafeNamesFailed,
    cafeNamesMessage: state.cafesReducer.cafeNamesMessage,
    cafeNamesError: state.cafesReducer.cafeNamesError,

    cafeNamesListLoading: state.cafesReducer.cafeNamesListLoading,
    cafeNamesListFailed: state.cafesReducer.cafeNamesListFailed,
    cafeNamesListMessage: state.cafesReducer.cafeNamesListMessage,
    cafeNamesListError: state.cafesReducer.cafeNamesListError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAllCafeNamesForPanel: () => dispatch(cafeActions.getAllCafeNamesForPanel())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentsFilter);
